import { render } from "./ResetSesi.vue?vue&type=template&id=dd4286b6"
import script from "./ResetSesi.vue?vue&type=script&lang=js"
export * from "./ResetSesi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\DEVAREA\\OFFICE\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__